const Endpoints = {
    // Auth
    common: "/auth",
    login: "/auth/admin/login",
    forgotPassword: "/auth/admin/forgot_password",
    createNewpassword: "/auth/admin/save_password",
    deleteAccount: "/auth/delete-request",
    deleteUser: "/auth/delete-user/app",

    //Auth User
    commonAuthUser: "/profile/r-user",

    // Dashboard
    dashboardSlots: "/admin/dashboard",

    // Manage User
    getManageUsers: "/admin/manage-users/list",
    getUserDetails: "/admin/manage-users/get-user",
    updateUser: "/admin/manage-users/update-user",
    updateRetailStatus: "/admin/retailer_status",
    setTarget : "/admin/update_reward_points",
    approveMech: "/admin/approveMechanic",
    salesManagerList : "/profile/sales-manager/list",

    // Manage Admin
    getAdminList: "/manage-admin",
    getAdminByID: "/manage-admin",

    //Slot Creation
    createUserSlot: "/admin/create_slot",

    //Product Enquiry
    productEnquiry: '/product-enquiry',
    productEnquiryList: '/product-enquiry/list',
    resolveProduct: '/product-enquiry/mark-resolved',
    mailToCustomer: '/product-enquiry/send-mail',

    //Manage content
    content: '/content',

    // Contact Form
    getContactForm: '/contact-form',
    getContactCount: '/contact-form/counts',
    getContactFormByID: '/contact-form',
    sendReplyForContact: '/contact-form/send-reply',

    // QR Code
    getQRList: '/qrcode/list_qr',
    getQRIndividualList: '/qrcode/list_child_qr',
    getQRBulList: '/qrcode/list_gchild_qr',
    sendIndividualQR: '/qrcode/single_qr',
    sendBulkQR: '/qrcode/bulk_qr',
    downloadQR: '/qrcode/download_qr',
    downloadBulkQR: '/qrcode/download_bulk_qr',
    bulkUploadQR : '/qrcode/upload-bulk-qr',
    individualUploadQR : '/qrcode/upload-single-qr',
    scannedActivity: "/qrcode/scanned-list",

    manageUserReportbyUser:"/qrcode/get-all-user-list",
    manageUserReport: "/qrcode/get-scanned-user-list",

    manageUserPDFbyPoints:"/qrcode/download-bypoints-scan-details",
    manageUserPDF:"/qrcode/download-scannedqr-details",
    manageUserReportdownloadbyDate:"/qrcode/download-scannedqr-bydate-details",

    // Product
    getProduct: '/product',
    getProductList: '/product//list/get-products',

    // Resources
    getResources: '/resource',
    getResourcesByID: '/resource',

    // Application
    getApplication: '/application',

    // Rewards
    getRewards: '/reward',
    getRewardByID: '/reward',

    //Add Points
    addPoints: '/reward/addPointsToUser/points',

    // product catalog
    getFilter : '/filter',
    filterUpload : '/filter/upload',
    getTruckSolution : '/truck-solution',
    truckSolutionUpload : '/truck-solution/upload',
    getBulkFilter : '/bulk-filteration',
    getSpecifiBulkFilter : '/bulk-filteration/getByID',
    activeInactive : "/product/activeAndInactiveProduct",
    //Get country code
    countryCode : '/profile/country/list',

    // Sub category dropdown
    subCategoryDropdown : '/product/sub-categories',

    //Application ID
    applicationId : '/application',

    // SINGLE File Upload
    singleUpload : '/upload/single',
    
    // Notification
    getNotification: '/offer-notification/list',
    getNotificationDetails: '/offer-notification',
    getNotificationByID: '/offer-notification',
    getAdminNotification: '/admin/notifications',

    // Loyalty Program
    getLoyaltyProgram: '/membership',
    //Feedback
    getFeedbackList : '/product-feedback/list',
    feebackItem : '/product-feedback',
    replyToFeedback : '/product-feedback/admin/reply',

    //redeem Rewards
    getRedeemRewardsList : '/redeem-reward/list',
    redeemRewardsItem : '/redeem-reward',
    redeemReply : '/redeem-reward/send-reply',

    //external sites
    aboutUs : '/about-us',

    // User Profile
    adminProfile : '/manage-admin/get/profile',
    newPassword : '/auth/admin/new/password',

    //Retailer TOD
    getRetailerList : '/retailer-tod/list-report',
    getOneRetailer : '/retailer-tod/report',
    downloadReport : '/retailer-tod/download-report',
    uploadReport : '/retailer-tod/upload-report',
    confirmReport : '/retailer-tod/confirm-report',

    //App Analytics
    getAdminAnalytics : "/admin/analytics/admin",
    rewardRedeemedFirstTime : "/admin/redeemed-first-time/admin",
    firstTimeQRScanned : "/admin/first-time-qr-scanned/admin",
    repeatedQRScanned : "/admin/scanned-qr-repeat-30-days/admin",
    failedQRScans : "/admin/failed-qr-scans/admin",
    totalQRScansByActiveusers : "/admin/total_qr_scans/admin",
    totalQRScanByDeletedUsers : "/admin/total_qr_scans/admin",

    //manage user roles
    getUserRolesList : "/admin/pending-users/list",
    userRoleChange : "/admin/user/change-role"
}

const APIMethods = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATch",
}

const Exported = {
    Endpoints,
    APIMethods
}

export default Exported